import axios, {AxiosResponse} from 'axios'

const API_URL = process.env.REACT_APP_THEME_API_URL

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface ReturnRecord {
  process_return_id: number
  company_id: number
  warehouse_id: number
  product_id: number
  return_type: string
  transaction_reference: string
  return_date: string
  quantity: number
  reason: string
  condition: string
  refund_amount: number
  restock_fee: number
  action_required: string
  processed_by: string
  notes: string
}

export interface WarehouseOption {
  warehouse_id: number
  warehouse_name: string
  status?: string
}

export interface ProductOption {
  product_id: number
  product_name: string
  status?: string
}

// ─── Returns APIs ─────────────────────────────────────────────────────────────

export const getReturns = async (companyId: string): Promise<ReturnRecord[] | undefined> => {
  return await axios
    .get(`${API_URL}/process-returns/list/${companyId}`)
    .then((response: AxiosResponse<ReturnRecord[]>) => response.data)
    .then((response: ReturnRecord[]) => response)
}

export const createReturn = async (body: any): Promise<{detail: string} | undefined> => {
  try {
    const response = await axios.post(`${API_URL}/process-returns/`, body)
    return response.data
  } catch (error: any) {
    if (error.response) {
      throw error.response.data
    }
  }
}

export const deleteReturn = async (
  companyId: string,
  returnId: number
): Promise<{detail: string} | undefined> => {
  return await axios
    .delete(`${API_URL}/process-returns/${companyId}/${returnId}`)
    .then((response: AxiosResponse<{detail: string}>) => response.data)
    .then((response: {detail: string}) => response)
}

// ─── Options APIs (for form dropdowns) ───────────────────────────────────────

export const getWarehouseOptions = async (
  companyId: string
): Promise<WarehouseOption[] | undefined> => {
  return await axios
    .get(`${API_URL}/warehouse/list/${companyId}`)
    .then((response: AxiosResponse<WarehouseOption[]>) => response.data)
    .then((response: WarehouseOption[]) => response.filter((item) => item.status === 'active'))
}

export const getProductOptions = async (
  companyId: string
): Promise<ProductOption[] | undefined> => {
  return await axios
    .get(`${API_URL}/product-catalogue/list/${companyId}`)
    .then((response: AxiosResponse<ProductOption[]>) => response.data)
    .then((response: ProductOption[]) => response.filter((item) => item.status === 'active'))
}
